import type { DocumentItem } from '../types/application';

export const initialDocuments: DocumentItem[] = [
  {
    id: 'id',
    name: 'Driver’s license',
    reason: 'Confirms your identity. Front and back.',
    status: 'accepted',
    files: ['license-front.jpg', 'license-back.jpg'],
    category: 'Identity',
  },
  {
    id: 'paystub',
    name: 'Recent paystubs',
    reason: 'Your last 30 days of pay from {{employerName}}.',
    status: 'needed',
    files: [],
    category: 'Income',
  },
  {
    id: 'w2',
    name: 'W-2s for 2024 and 2025',
    reason: 'Shows your income history for the last two years.',
    status: 'reviewing',
    files: ['w2-2024.pdf', 'w2-2025.pdf'],
    category: 'Income',
  },
  {
    id: 'bank',
    name: 'Bank statements',
    reason: 'Two most recent months for your {{primaryAccountName}} checking account, all pages.',
    status: 'attention',
    note: 'Page 3 of your August statement is missing.',
    files: ['chase-aug.pdf'],
    category: 'Assets',
  },
  {
    id: 'retirement',
    name: 'Retirement statement',
    reason: 'Most recent quarterly statement for your Fidelity 401(k).',
    status: 'needed',
    files: [],
    category: 'Assets',
  },
  {
    id: 'contract',
    name: 'Purchase agreement',
    reason: 'The signed contract for {{propertyStreet}}, with any addenda.',
    status: 'uploaded',
    files: ['purchase-agreement.pdf'],
    category: 'Property',
  },
  {
    id: 'insurance',
    name: 'Homeowners insurance quote',
    reason: 'A quote or binder from your insurance agent for the new home.',
    status: 'needed',
    files: [],
    category: 'Property',
  },
  {
    id: 'dd214',
    name: 'DD-214',
    reason: 'Your military discharge record — it may qualify you for VA benefits.',
    status: 'needed',
    files: [],
    category: 'Eligibility',
  },
];
